import { createContext } from 'react'

export type SidebarContextType = {
  sidebarOpen: boolean
  setSidebarOpen: (value: boolean) => void
  sidebarWidth: number
  setSidebarWidth: (value: number) => void
}
export const sidebarContext = createContext<SidebarContextType | undefined>(undefined)
